export default __webpack_public_path__ + "static/visual-app-builder-0-ff22c4b2bd9325ffc225ca6a60c04313.png";